// @flow
import React, { useState, useEffect } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/rail.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { ArticleTeasers, SortMode } from '@ta-interaktiv/react-article-teasers'
import { hot } from 'react-hot-loader/root'
import { Footer } from '@ta-interaktiv/react-footer'
import { MapBox } from '../mapBox'
import { NominatimSearch } from '../nominatimSearch'
import { Sources } from '../Sources'
// import { Waypoint } from 'react-waypoint'
import { InterfaceText } from 'types/IText'
import { MDXText } from '../MDXText'
import { UserFeedback } from '@ta-interaktiv/react-user-feedback'
import GetSheetDone from 'get-sheet-done'
import { CANTONSNODATA } from '../../images/settings.js'
const spreadsheetID = '1F2tToQl-taJ3YYfhsQpANGKcS5eWZ-54ZKy1nnFiXKY'
const locale = 'de'
// interface TeaserProps {
//   data: string[]
//   title: string
//   updated: string
// }
var teaserIDs: string[] = []

// Quellen
const sourcesData = require('../../images/sources.csv')

interface InterfaceTexts {
  de: InterfaceText
  fr: InterfaceText
  [key: string]: InterfaceText
}
var texts: InterfaceTexts = require('./text.de.yml')

const ARTICLE_ID = '19513221'

// console.log = () => {}
// console.warn = () => {}
// console.error = () => {}
// console.group = () => {}
// console.groupEnd = () => {}
// console.groupCollapsed = () => {}
// console.exception = () => {}

function AppComponent() {
  const [map, setMap] = useState({})
  const [teaser, setTeaser] = useState(teaserIDs)

  useEffect(() => {
    // Load articleIDs from Spreadsheet
    GetSheetDone.raw(spreadsheetID).then(
      (sheet: { data: string[]; title: string; updated: string }) => {
        var teaser = sheet.data.filter(f => {
          if (f[0] === locale) return f
        })
        teaser[0].shift()
        setTeaser(teaser[0])
      }
    )
  }, [])
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} inverted />
      <ThemeSwitch />
      <header className='ui vertical fitted segment'>
        <div className='ui  container'>
          <h2>{texts.title}</h2>
        </div>
      </header>
      <div className='ui vertical segment lead'>
        <div className='ui text container'>        <a href='https://interaktiv.tagesanzeiger.ch/2020/schweizer-gefahrenkarte/'><img src={require('images/chgfk-teaser_banner.jpg')} style={{width:'100%',marginBottom:'2em',marginTop:'2em'}}/></a>

          <div className=' ta lead'>{texts.lead}</div>
        </div>
      </div>
      <div className='ui  text  container'>
        <MDXText file={'intro.' + locale + '.mdx'} />
      </div>
      <div className='ui segment mapSegment'>
        <div className='ui text container smallK'>
          <div className='smallKey'>
            <div className='title'>{texts.keytitle}</div>

            <div className='group'>
              <div className='kat'>
                <span> {texts.mapBox.water}</span>
              </div>
              <div className='swatch slight water' />
              <div className='swatch mean water' />
              <div className='swatch subst water' />
              <div className='name'> {texts.steps[2]}</div>
              <div className='name'> {texts.steps[1]}</div>
              <div className='name'> {texts.steps[0]}</div>
            </div>
            <div className='group'>
              <div className='kat'>
                <span> {texts.mapBox.ava}</span>
              </div>
              <div className='swatch slight ava' />
              <div className='swatch mean ava' />
              <div className='swatch subst ava' />
              <div className='name'> {texts.steps[2]}</div>
              <div className='name'> {texts.steps[1]}</div>
              <div className='name'> {texts.steps[0]}</div>
            </div>
          </div>
        </div>
        <div className='ui text container disclaimer'>{texts.disclaimer}</div>
        <div className='ui container nomiContainer'>
          <div className='ui text container nomi'>
            <NominatimSearch map={map} locales={texts.search} />
          </div>
        </div>

        <MapBox registerMap={setMap} locales={texts.mapBox} />
      </div>
      <div className='ui text container'>
        <div className='dataHint'>
          {texts.dataHint[0]}
          <br />
          {texts.dataHint[1]}
        </div>
      </div>

      <div className='ui text container bottomKey'>
        {CANTONSNODATA.length > 0 && (
          <div className='smallKey'>
            <div className='group'>
              <div className='swatch noData' />
              <div className='name full'>{texts.noPub}</div>
            </div>
          </div>
        )}
      </div>

      <div className='ui text container'>
        <div className='legende'>
          <div className='type'>
            <MDXText file={'meaning.' + locale + '.mdx'} />
          </div>

          <div className='type'>
            <MDXText file={'desicion.' + locale + '.mdx'} />
          </div>

          <div className='type'>
            <MDXText file={'hazardNote.' + locale + '.mdx'} />
          </div>
        </div>
        <UserFeedback
          articleId={ARTICLE_ID}
          questions={texts.feedbackQuestions}
          locale={locale}
          starColor='blue'
        />
      </div>
      {teaser.length > 0 && (
        <div className='ui vertical segment '>
          <div className='ui container '>
            <ArticleTeasers
              sorting={SortMode.REVERSE_CHRONOLOGICALLY_BY_CREATION_DATE}
              numberOfCards='three'
              articleIds={teaser}
            />
          </div>
        </div>
      )}
      <div className='ui vertical segment methodik' id='methodik'>
        <div className='ui text container'>
          <h4>Methodik</h4>
          <div className='type'>
            <MDXText file={'feedback.' + locale + '.mdx'} />
          </div>
          <div className='type'>
            <MDXText file={'technical.' + locale + '.mdx'} />
            <Sources sources={sourcesData} locales={texts.sources} />
          </div>
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        questions={texts.feedbackQuestions}
        locale={locale}
        locales={texts.credits[3]}
        credits={[
          [
            texts.credits[0],
            'Sylvain Besson, Oliver Zihlmann (Tamedia Recherchedesk), Luca De Carli (Tamedia Inland), Marius Aschwanden, Cedric Fröhlich (Berner Zeitung), Dominik Balmer (Sonntagszeitung)'
          ],
          [texts.credits[1], 'Patrick Meier, Duc-Quang Nguyen (Daten-Team)'],
          [texts.credits[2], 'Sebastian Broschinski (Interaktiv-Team)']
        ]}
        hideUserFeedback
      />
    </div>
  )
}

export default hot(AppComponent)
